import { render, staticRenderFns } from "./BdrFws_1d01_P20.vue?vue&type=template&id=108ea505&"
import script from "./BdrFws_1d01_P20.vue?vue&type=script&lang=js&"
export * from "./BdrFws_1d01_P20.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports